export  class UsuarioProyecto {
    idEmpresa?: number = 1;
    idProyecto?:number = -1;
    idUsuario?: number = -1;
    idEmpresaAfiliada?:number= -1;
    estatus?:string="";
    fechaHoraUM?:Date;
    idsEmpresasAfiliadas:string = "";
    idUsuarioUM:number = -1;
    accesoBackOffice?:number = 0;
}
